/**
 * Validation rule constants
 */

// Field length limits
export const FIELD_LIMITS = {
  EMAIL: {
    MIN: 5,
    MAX: 254
  },
  PASSWORD: {
    MIN: 8,
    MAX: 128
  },
  NAME: {
    MIN: 2,
    MAX: 50
  },
  PHONE: {
    MIN: 10,
    MAX: 15
  },
  MESSAGE: {
    MIN: 10,
    MAX: 1000
  },
  TITLE: {
    MIN: 3,
    MAX: 100
  },
  DESCRIPTION: {
    MIN: 10,
    MAX: 500
  }
};

// Validation messages
export const VALIDATION_MESSAGES = {
  REQUIRED: 'This field is required',
  INVALID_EMAIL: 'Please enter a valid email address',
  INVALID_PHONE: 'Please enter a valid phone number',
  PASSWORD_TOO_SHORT: `Password must be at least ${FIELD_LIMITS.PASSWORD.MIN} characters`,
  PASSWORD_TOO_WEAK: 'Password must contain uppercase, lowercase, number and special character',
  PASSWORDS_DONT_MATCH: 'Passwords do not match',
  INVALID_DATE: 'Please enter a valid date',
  INVALID_URL: 'Please enter a valid URL',
  TOO_SHORT: (min) => `Must be at least ${min} characters`,
  TOO_LONG: (max) => `Must be no more than ${max} characters`,
  INVALID_FORMAT: 'Invalid format',
  NUMERIC_ONLY: 'Only numbers are allowed',
  ALPHA_ONLY: 'Only letters are allowed',
  ALPHANUMERIC_ONLY: 'Only letters and numbers are allowed'
};

// Regular expressions for validation
export const REGEX_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^\+?[\d\s\-\(\)]{10,}$/,
  PASSWORD_STRONG: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/,
  NUMERIC: /^\d+$/,
  ALPHA: /^[a-zA-Z]+$/,
  ALPHANUMERIC: /^[a-zA-Z0-9]+$/,
  URL: /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/,
  DATE_ISO: /^\d{4}-\d{2}-\d{2}$/,
  TIME_24H: /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/,
  POSTAL_CODE: /^\d{5}(-\d{4})?$/,
  CREDIT_CARD: /^\d{13,19}$/,
  CVV: /^\d{3,4}$/,
  /** Consumer email domains blocked for Airliner signup */
  AIRLINER_FREE_EMAIL: /^([\w-.]+@(gmail\.com|yahoo\.com|hotmail\.com|mail\.ru|yandex\.ru|mail\.com))$/i,
};

export const AIRLINER_FREE_EMAIL_MESSAGE =
  'Free email addresses are not allowed. Please enter a valid corporate email';

export const isAirlinerFreeEmail = (email) =>
  REGEX_PATTERNS.AIRLINER_FREE_EMAIL.test(String(email || '').trim().toLowerCase());

// File upload constraints
export const FILE_CONSTRAINTS = {
  MAX_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_TYPES: {
    IMAGES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
    DOCUMENTS: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ALL: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'application/pdf']
  }
};

// Form validation rules
export const VALIDATION_RULES = {
  REQUIRED_FIELDS: {
    LOGIN: ['email', 'password'],
    REGISTER: ['firstName', 'lastName', 'email', 'password', 'confirmPassword'],
    PROFILE: ['firstName', 'lastName', 'email', 'phone'],
    BOOKING: ['passengers', 'contactEmail', 'contactPhone'],
    PAYMENT: ['cardNumber', 'expiryDate', 'cvv', 'cardholderName']
  },
  
  OPTIONAL_FIELDS: {
    PROFILE: ['middleName', 'dateOfBirth', 'address', 'city', 'country'],
    BOOKING: ['specialRequests', 'seatPreference'],
    CONTACT: ['company', 'website']
  }
};